import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins";
import vuetify from "@/plugins/vuetify";
import { sync } from "vuex-router-sync";
import db from "@/plugins/db";
import log from "@/mixins/log";

sync(store, router);

Vue.config.productionTip = false;
Vue.mixin(log);

new Vue({
  router,
  store,
  vuetify,
  created() {
    // firestoreのデータをstoreで扱いたい場合、collection/documentの取得開始をここに書く
    // administratorsは未ログインだと読み取りできないため取得開始をここに書かないことに注意
    this.$store.dispatch(
      "setCategoryRef",
      db
        .collection("categoryMaster")
        .where("isDelete", "==", false)
        .orderBy("sortKey")
    );
    this.$store.dispatch(
      "setCodeRef",
      db
        .collection("codeMaster")
        .where("isDelete", "==", false)
        .orderBy("sortKey")
    );
    this.$store.dispatch(
      "setCompanyRef",
      db
        .collection("companyMaster")
        .where("isDelete", "==", false)
        .orderBy("sortKey")
    );
    this.$store.dispatch(
      "setExternalLinkRef",
      db
        .collection("externalLinkMaster")
        .where("isDelete", "==", false)
        .orderBy("sortKey")
    );
    this.$store.dispatch(
      "setExternalLowerLinkRef",
      db
        .collection("externalLowerLinkMaster")
        .where("isDelete", "==", false)
        .orderBy("sortKey")
    );
    this.$store.dispatch(
      "setFacilitiesRef",
      db
        .collection("facilityMaster")
        .where("isDelete", "==", false)
        .orderBy("sortKey")
    );
    this.$store.dispatch(
      "setGateRef",
      db
        .collection("gateMaster")
        .where("isDelete", "==", false)
        .orderBy("sortKey")
    );
    this.$store.dispatch(
      "setGroupRef",
      db
        .collection("groupMaster")
        .where("isDelete", "==", false)
        .orderBy("sortKey")
    );
    this.$store.dispatch(
      "setOptionsRef",
      db
        .collection("optionMaster")
        .where("isDelete", "==", false)
        .orderBy("sortKey")
    );
    this.$store.dispatch(
      "setPriceRef",
      db.collection("priceMaster").orderBy("sortKey")
    );
    this.$store.dispatch(
      "setRouteSearchKeywordRef",
      db
        .collection("routeSearchKeywordMaster")
        .where("isDelete", "==", false)
        .orderBy("sortKey")
    );
    this.$store.dispatch(
      "setEnvironmentRef",
      db.collection("system").doc("environment")
    );
    this.$store.dispatch(
      "setManagementRef",
      db.collection("system").doc("management")
    );
    this.$store.dispatch(
      "setPropertiesRef",
      db.collection("system").doc("properties")
    );
    this.$store.dispatch(
      "setRouteSearchRef",
      db.collection("system").doc("routeSearch")
    );
    this.$store.dispatch(
      "setTicketRef",
      db
        .collection("ticketMaster")
        .where("isDelete", "==", false)
        .orderBy("sortKey")
    );
  },
  render: (h) => h(App),
}).$mount("#app");
